
/**
 * @function
 * Determine if this EIM string is at least 13 characters and no
 * more than 18.  Anything else isn't considered a valid input.
 * @param {string} eim
 */
export const isEimValidLength = (eim: string) => {
  return eim.length >= 13 && eim.length <= 18;
}

/**
 * @function
 * Takes in an EIM and capitalizes the letters and pads it out
 * to 18 characters using -'s.
 * @param {string} eim
 */
export const cleanupEim = (eim: string) => {
  let output = eim.trim().toUpperCase();

  while (output.length < 18) {
    output = output.concat('-');
  }

  return output;
}

/**
 * @function
 * Parses the EIM string into ConfigurationOption codes. Any -'s are
 * converted to an "STD" string.
 * @param {string} eim
 */
export const parseEim = (eim: string) => {
  let codeList: string[] = [];
  const eimCharArray = eim.split('');
  for (let i = 0; i < eimCharArray.length; i++) {
    let code = '';
    // Configuration Option for EIM character index equal to 2
    if (i === 1) {
      code = i + 1 + '_' + eimCharArray[i] + eimCharArray[i + 1];
      i++;
    }
    // Configuration Option for EIM character index equal to 8
    else if (i === 7) {
      code = i + 1 + '_' + eimCharArray[i] + eimCharArray[i + 1] + eimCharArray[i + 2];
      i += 2;
    }
    // All other Configuration Options
    else {
      if (eimCharArray[i] === '-' || eimCharArray[i] === '_') {
        code = i + 1 + '_STD';
      }
      else {
        code = i + 1 + '_' + eimCharArray[i];
      }
    }

    codeList = codeList.concat(code);
  }

  return codeList;
}
